// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivateDtaWorkflowRequest
 */
export interface ActivateDtaWorkflowRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivateDtaWorkflowRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDtaWorkflowRequest
     */
    version?: string;
}

/**
 * Check if a given object implements the ActivateDtaWorkflowRequest interface.
 */
export function instanceOfActivateDtaWorkflowRequest(value: object): value is ActivateDtaWorkflowRequest {
    return true;
}

export function ActivateDtaWorkflowRequestFromJSON(json: any): ActivateDtaWorkflowRequest {
    return ActivateDtaWorkflowRequestFromJSONTyped(json, false);
}

export function ActivateDtaWorkflowRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivateDtaWorkflowRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function ActivateDtaWorkflowRequestToJSON(json: any): ActivateDtaWorkflowRequest {
    return ActivateDtaWorkflowRequestToJSONTyped(json, false);
}

export function ActivateDtaWorkflowRequestToJSONTyped(value?: ActivateDtaWorkflowRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'version': value['version'],
    };
}
